import script from "./NewUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUserView.vue?vue&type=script&setup=true&lang=js"

import "./NewUserView.vue?vue&type=style&index=0&id=6defbf47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6defbf47"]])

export default __exports__